<template>
  <KTCodePreview v-bind:title="'Chỉnh sửa nhà cung cấp'">
    <template v-slot:preview>
      <ProviderForm
        v-if="!initialLoading && providerToEdit"
        ref="providerForm"
        :is-loading="formSubmitting"
        :initial-data="providerToEdit"
        :is-edit-mode="true"
        :provider-id="providerId"
      />
      <div
        v-if="initialLoading && !providerToEdit"
        class="text-center p-5"
      >
        <b-spinner label="Loading..."></b-spinner>
        <p
          v-if="fetchError"
          class="text-danger mt-2"
        >{{ fetchError }}</p>
      </div>
    </template>

    <template v-slot:foot>
      <b-container class="bv-example-row">
        <b-row>
          <b-button
            v-if="false"
            style="fontweight: 600; width: 70px"
            variant="primary"
            size="sm"
            @click="handleSubmit"
            :disabled="formSubmitting || initialLoading || !providerToEdit"
          >Lưu</b-button>
          <router-link
            to="/providers"
            tag="button"
          >
            <b-button
              style="margin-left: 10px; font-weight: 600; width: 70px"
              variant="secondary"
              size="sm"
            >Hủy</b-button>
          </router-link>
        </b-row>
      </b-container>
    </template>
  </KTCodePreview>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ProviderRepository from '@/repositories/ProviderRepository';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import ProviderForm from './shared/components/ProviderForm.vue';

const KTCodePreview = () =>
  import(/* webpackPrefetch: true */ '@/view/content/CodePreview.vue');

export default {
  name: 'UpdateProvider',
  components: {
    ProviderForm,
    KTCodePreview,
  },
  data() {
    return {
      initialLoading: false,
      formSubmitting: false,
      providerToEdit: null,
      providerId: null,
      fetchError: null,
    };
  },
  computed: {
    pageLoading() {
      return this.initialLoading || this.formSubmitting;
    },
  },
  created() {
    this.providerId = this.$route.query.id;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Nhà cung cấp', route: '/providers' },
      { title: 'Danh sách nhà cung cấp', route: '/providers' },
      { title: 'Cập nhật nhà cung cấp' },
    ]);
    if (this.providerId) {
      this.fetchProviderData();
    } else {
      this.fetchError = 'Không tìm thấy ID nhà cung cấp.';
      makeToastFaile(this.fetchError);
    }
  },
  methods: {
    async fetchProviderData() {
      this.initialLoading = true;
      this.fetchError = null;
      try {
        const responseData = await ProviderRepository.getById(this.providerId, {
          includeSupplierGroup: true,
        });

        this.providerToEdit = {
          ...responseData.provider,
          supplierGroupName: responseData.provider.supplierGroup?.name || '',
          parentId:
            responseData.provider.parentId ??
            responseData.provider.parent?.id ??
            null,
        };
      } catch (error) {
        console.error('Error fetching provider data:', error);
        this.providerToEdit = null;
        this.fetchError =
          error?.response?.data?.message || 'Lỗi khi tải dữ liệu nhà cung cấp.';
        makeToastFaile(this.fetchError);
      } finally {
        this.initialLoading = false;
      }
    },
    async handleSubmit() {
      if (this.formSubmitting || !this.$refs.providerForm) return;
      const formData = this.$refs.providerForm.submit();

      if (formData) {
        this.formSubmitting = true;
        const payload = {
          ...formData,
          id: this.providerId,
        };
        delete payload.code;

        try {
          const response = await ProviderRepository.update(
            this.providerId,
            payload,
          );
          makeToastSuccess(
            response.message || 'Cập nhật nhà cung cấp thành công!',
          );
          this.$router.push({ name: 'list-provider' });
        } catch (error) {
          console.error('Error updating provider:', error);
          const message =
            error?.response?.data?.message ||
            'Có lỗi xảy ra khi cập nhật nhà cung cấp.';
          makeToastFaile(message);
        } finally {
          this.formSubmitting = false;
        }
      }
    },
  },
};
</script>

<style scoped>
/* .form-group label {
  font-weight: 500;
} */

.form-group label:has(:after) {
  font-weight: 500;
}
</style>
